import { render, staticRenderFns } from "./ProjectPlanningConfigComponent.vue?vue&type=template&id=45bdafae&scoped=true&"
import script from "./ProjectPlanningConfigComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectPlanningConfigComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlanningConfigComponent.vue?vue&type=style&index=0&id=45bdafae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdafae",
  null
  
)

export default component.exports